import axios from 'axios'
import { checkTaskCompletion } from './integrationHub.crud'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const GROUPS_URL = `${ROOT}/customer/:customerId/microsoft/groups`
export const DIRECTORY_ROLES_URL = `${ROOT}/customer/:customerId/microsoft/directory-roles`
export const GROUP_BY_ID_URL = `${GROUPS_URL}/:groupId`
export const GROUP_MEMBERS_URL = `${GROUP_BY_ID_URL}/members`
export const GROUP_OWNERS_URL = `${GROUP_BY_ID_URL}/owners`
export const GROUP_ROLES_URL = `${GROUP_BY_ID_URL}/roles`

export function getDirectoryRoles({ customerId }) {
  return axios.get(DIRECTORY_ROLES_URL.replace(':customerId', customerId))
}

export function getGroups({ customerId, groupTypes, includeMembersAndOwnersCount = false }) {
  const params = {
    includeMembersAndOwnersCount,
  }

  if (groupTypes) {
    params.groupType = groupTypes?.join(',')
  }

  return axios.get(GROUPS_URL.replace(':customerId', customerId), {
    params,
  })
}

export function getGroupById({ customerId, groupId }) {
  return axios.get(GROUP_BY_ID_URL.replace(':customerId', customerId).replace(':groupId', groupId))
}

export function getGroupMembers({ customerId, groupId }) {
  return axios.get(GROUP_MEMBERS_URL.replace(':customerId', customerId).replace(':groupId', groupId))
}

export function getGroupOwners({ customerId, groupId }) {
  return axios.get(GROUP_OWNERS_URL.replace(':customerId', customerId).replace(':groupId', groupId))
}

export function getGroupRoles({ customerId, groupId }) {
  return axios.get(GROUP_ROLES_URL.replace(':customerId', customerId).replace(':groupId', groupId))
}

export const postGroup = async ({ customerId, userId, payload, source }) => {
  const taskResponse = await axios.post(GROUPS_URL.replace(':customerId', customerId), payload, {
    params: { customerId, userId, source },
  })

  await checkTaskCompletion(taskResponse)
}

export const putGroup = async ({ customerId, userId, payload }) => {
  const { groupId } = payload
  if (!groupId) {
    throw new Error('groupId is required for update')
  }
  const taskResponse = await axios.put(
    GROUP_BY_ID_URL.replace(':customerId', customerId).replace(':groupId', groupId),
    payload,
    {
      params: { customerId, userId },
    },
  )

  await checkTaskCompletion(taskResponse)
}

export const deleteGroup = async ({ customerId, userId, groupId }) => {
  const taskResponse = await axios.delete(
    GROUP_BY_ID_URL.replace(':customerId', customerId).replace(':groupId', groupId),
    {
      params: { customerId, userId },
    },
  )

  await checkTaskCompletion(taskResponse)
}
